import { LockClosedIcon, LockOpenIcon } from '@heroicons/react/24/outline'
import React from 'react'
import { Tooltip } from 'stories/components'

interface LockButtonProps {
  locked: boolean | null
  canLock: boolean
  onToggle: () => void
  className?: string
  size?: 'sm' | 'md'
  tooltip?: string
}

export const LockButton: React.FC<LockButtonProps> = ({
  locked,
  canLock,
  onToggle,
  className = '',
  size = 'sm',
  tooltip,
}) => {
  if (!canLock) return null

  const iconClass = size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4'
  const isUnset = locked === null
  const btnClass = `inline-flex items-center justify-center rounded p-0.5 transition-colors
    ${
      isUnset
        ? 'text-gray-400 opacity-40'
        : locked
        ? 'text-red-600 hover:text-red-800'
        : 'text-gray-500 hover:text-blue-600'
    }
    ${canLock ? 'cursor-pointer' : 'cursor-default'}
    ${className}`

  const label = tooltip ?? (locked === true ? 'Unlock field' : 'Lock field')
  const Icon = locked === true ? LockClosedIcon : LockOpenIcon

  const button = (
    <span
      role={canLock ? 'button' : undefined}
      tabIndex={canLock ? 0 : undefined}
      aria-label={label}
      className={btnClass}
      onClick={canLock ? onToggle : undefined}
      onKeyDown={canLock ? (e) => e.key === 'Enter' && onToggle() : undefined}
    >
      <Icon className={iconClass} />
    </span>
  )

  return <Tooltip message={label}>{button}</Tooltip>
}
